module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-img"
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "accept": "image/*,.pdf",
      "on-success": _vm.handleSuccess,
      "action": "https://jsonplaceholder.typicode.com/posts/",
      "before-upload": _vm.beforeUpload,
      "on-remove": _vm.handleRemove,
      "on-progress": _vm.handleProgress,
      "show-file-list": false,
      "list-type": "picture"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [(_vm.fileList.length === 0) ? _c('span', [_vm._v("点击上传")]) : _c('span', [_vm._v("更新图片")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传 jpg/jpeg/png/pdf 文件，且不超过 2M")])], 1), _vm._v(" "), (_vm.upstate != 'wait') ? _c('div', {
    staticClass: "imgCard"
  }, [(_vm.upstate != 'uploaded') ? _c('el-progress', {
    staticClass: "pgress",
    attrs: {
      "width": "90",
      "type": "circle",
      "percentage": _vm.upgress
    }
  }) : _c('img', {
    attrs: {
      "src": "",
      "alt": ""
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-3591abc0"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/Enterprise/announcement/src/imgUpload.vue
// module id = 1449
// module chunks = 1